import axios from 'axios';

export type LocationSearchAddress = {
  municipality?: string;
  countrySubdivision?: string;
  country?: string;
};

export type LocationSearchResult = {
  address?: LocationSearchAddress;
};

const AZURE_MAPS_API_KEY = 'cTbC9G2Tkk76cfNABIKl5rrAdh0K5_PP_1pmc1zCN3Y';
const AZURE_MAPS_BASE_URL = 'https://atlas.microsoft.com/search/address/json';

export const searchLocations = async (query: string): Promise<LocationSearchResult[]> => {
  const trimmed = query.trim();
  if (!trimmed) {
    return [];
  }

  try {
    const { data } = await axios.get(
      `${AZURE_MAPS_BASE_URL}?api-version=1.0&entityType=Municipality&query=${encodeURIComponent(
        trimmed
      )}&subscription-key=${AZURE_MAPS_API_KEY}`
    );
    return Array.isArray(data?.results) ? data.results : [];
  } catch (error) {
    console.error('Location search failed:', error);
    return [];
  }
};

export const formatLocationAddress = (address?: LocationSearchAddress): string => {
  return [address?.municipality, address?.countrySubdivision, address?.country]
    .filter(Boolean)
    .join(', ');
};
